/**
 * Shared UI component for UI Form Section.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { UiCardComponent } from '../ui-card/ui-card.component';
import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

/**
 * COMPONENT: Ui Form Section
 * Inputs: Uses the parameters, injected services, route state, or signal state declared by this file.
 * Output: Returns the documented value or updates component/service state without changing the public contract.
 * Processing: Documents the Angular declaration that connects this class to templates, dependency injection, or template transforms.
 */
@Component({
  selector: 'ui-form-section',
  standalone: true,
  imports: [UiCardComponent, UiLabelTranslatePipe],
  templateUrl: './ui-form-section.component.html',
  styleUrl: './ui-form-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiFormSectionComponent {
  readonly title = input.required<string>();
  /** PARENT-CHILD CONTRACT: description documents the input state boundary used by this file. */
  readonly description = input('');
  /** PARENT-CHILD CONTRACT: required documents the input state boundary used by this file. */
  readonly required = input(false);
  readonly variant = input<'default' | 'compact'>('default');
}
